import * as React from 'react';

function SvgPmsIcon(props) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#pms-icon_svg__a)">
        <path d="M15.457 1.322l-.78-.78a.152.152 0 00-.21 0l-1.398 1.4a3.663 3.663 0 00-2.06-.631c-.942 0-1.883.358-2.602 1.077L6.534 4.261a.148.148 0 000 .208l4.995 4.995c.03.03.066.042.104.042a.155.155 0 00.105-.042l1.874-1.873a3.68 3.68 0 00.446-4.66l1.4-1.4a.15.15 0 000-.21zM9.23 8.637a.148.148 0 00-.208 0L7.797 9.86 6.137 8.2l1.226-1.226a.148.148 0 000-.208l-.67-.67a.148.148 0 00-.207 0L5.26 7.325l-.79-.79a.144.144 0 00-.105-.043.156.156 0 00-.105.042L2.388 8.407a3.68 3.68 0 00-.446 4.66l-1.4 1.399a.148.148 0 000 .208l.78.78c.03.029.066.041.105.041a.152.152 0 00.105-.042l1.399-1.399c.62.421 1.34.63 2.06.63.942 0 1.883-.358 2.602-1.077l1.873-1.873a.148.148 0 000-.208l-.79-.79L9.902 9.51a.148.148 0 000-.208l-.673-.665z" />
      </g>
      <defs>
        <clipPath id="pms-icon_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPmsIcon;
